import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle2, ArrowRight, PlusCircle } from "lucide-react";
import { PageHeader } from "@/business/components/PageHeader";
import HireBuskerForm from "@/business/components/HireBuskerForm";

export default function Hire() {
  const { user } = useOutletContext();
  const navigate = useNavigate();
  const [successOpen, setSuccessOpen] = useState(false);
  const [formKey, setFormKey] = useState(0); // bump to remount-form for "Post another"
  const [lastResult, setLastResult] = useState(null);

  const onSuccess = (result) => {
    setLastResult(result);
    setSuccessOpen(true);
  };
  const postAnother = () => {
    setSuccessOpen(false);
    setFormKey((k) => k + 1);
  };
  const viewGigs = () => {
    setSuccessOpen(false);
    navigate("/business/dashboard/gigs");
  };

  return (
    <div className="space-y-6" data-testid="hire-a-busker-page">
      <PageHeader
        title="Hire a Busker"
        description="Post a gig and let local performers apply. Your post is also visible to buskers in the BuskerBeat mobile app."
        action={(
          <Button variant="outline" onClick={() => navigate("/business/dashboard/gigs")} data-testid="hire-page-view-gigs-button">
            My Posted Gigs <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        )}
      />

      <Card className="border-[#E5E7EB] shadow-sm">
        <CardHeader><h2 className="text-base font-semibold">Gig details</h2></CardHeader>
        <CardContent>
          <HireBuskerForm
            key={formKey}
            business={user}
            autoLoadLocations={true}
            onSuccess={onSuccess}
            onUnauthorized={() => navigate("/business/login", { replace: true })}
            submitLabel="Post gig"
          />
        </CardContent>
      </Card>

      <Dialog open={successOpen} onOpenChange={setSuccessOpen}>
        <DialogContent data-testid="hire-success-dialog">
          <DialogHeader>
            <div className="mx-auto h-12 w-12 rounded-2xl bg-emerald-100 text-emerald-700 flex items-center justify-center mb-2">
              <CheckCircle2 className="h-7 w-7" />
            </div>
            <DialogTitle className="text-center">Your gig is live!</DialogTitle>
            <DialogDescription className="text-center">
              Buskers in {user?.country || "your area"} can now apply to your gig.
              {lastResult?.request_id && (<><br /><span className="text-[10px] font-mono text-[#6B7280]">ref: {lastResult.request_id.slice(0, 8)}…</span></>)}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex-col sm:flex-row gap-2">
            <Button variant="outline" onClick={postAnother} data-testid="hire-success-post-another-button"><PlusCircle className="mr-2 h-4 w-4" />Post another</Button>
            <Button onClick={viewGigs} className="bg-[#FF6A00] hover:bg-[#E85F00] text-white" data-testid="hire-success-view-gigs-button">View my gigs <ArrowRight className="ml-2 h-4 w-4" /></Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
